import { Component, Inject, Input, OnInit } from '@angular/core';
import { CmsComponentsFacade } from '@kion/data-access/data-access-cms-components';
import {
  CmsComponent,
  CmsLinkComponent,
  CmsLinkListComponent,
} from '@kion/data-models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { CmsConfig } from '../../config/cms.config';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'kion-cms-link-list',
  templateUrl: './link-list.component.html',
  styleUrls: ['./link-list.component.scss'],
})
export class LinkListComponent implements OnInit {
  @Input() component: CmsLinkListComponent;
  @Input() class: string;

  lazyLoadedComponents$: Observable<CmsLinkComponent[]>;

  cookieLink = 'KionCookieConsentLinkComponent';

  constructor(
    private cmsComponentsFacade: CmsComponentsFacade,
    private cookieService: CookieService,
    private cmsConfig: CmsConfig,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    if (!this.component.links) {
      return;
    }
    const components = this.component.links.split(' ');
    this.cmsComponentsFacade.loadByIds(components, components.join('_'));
    this.lazyLoadedComponents$ = this.cmsComponentsFacade.all$.pipe(
      map(
        (cmsComponents: CmsComponent[]) =>
          cmsComponents
            .filter((cmsComponent: CmsComponent) =>
              components.includes(cmsComponent.uid)
            )
            .sort((a, b) => {
              const indexA = components.indexOf(a.uid);
              const indexB = components.indexOf(b.uid);
              return indexA < indexB ? -1 : 1;
            }) as CmsLinkComponent[]
      )
    );
  }

  handleClick(component: CmsComponent) {
    if (component.typeCode === this.cookieLink) {
      this.cookieService.delete('marketing', this.cmsConfig.basePath);
      this.cookieService.delete('cookie-consent', this.cmsConfig.basePath);
      this.document.defaultView.location.reload();
    }
  }
}
